module.exports = __webpack_public_path__ + "img/logo-dark.db8915e6.png";